import { useLocation } from 'react-router-dom';
import { DynamicPageContent } from '../../config/Content.js';
const InnerBanner = () => {
    const location = useLocation();
    const locPath = location.pathname.split('/');
    const pageId = locPath[locPath.length - 1]
    const pageContentFilder = DynamicPageContent.filter(obj => obj.page === pageId)


    return (
        <>
            <div className="section inner_banner ">
                <div className="inner_bannerin">
                    <div className="bg">
                        <picture>
                            <source srcSet={pageContentFilder[0].banbglg} media="(min-width: 1440px)" />
                            <source srcSet={pageContentFilder[0].banbgmd} media="(max-width: 768px)" />
                            <source srcSet={pageContentFilder[0].banbg} />
                            <img src={pageContentFilder[0].banbg} alt="about us" />
                        </picture>
                    </div>
                    <div className="position-absolute bottom-0 start-0 end-0">
                        <div className="container mb-5 text-white">
                            <h1 className="title fwbold">
                                {pageContentFilder[0].title}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InnerBanner;